import { useState } from 'react';
import SedeSelector from './SedeSelector';

interface TopBarProps {
  onToggleSidebar: () => void;
  onLogout: () => void;
  leftContent?: React.ReactNode;
}

export default function TopBar({ onToggleSidebar, onLogout, leftContent }: TopBarProps) {
  const [showProfile, setShowProfile] = useState(false);
  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sm:px-6 sticky top-0 z-30">
      <div className="flex items-center gap-2 sm:gap-4 flex-1 min-w-0">
        <button
          onClick={onToggleSidebar}
          className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-slate-100 transition flex-shrink-0"
        >
          <i className="ri-menu-line text-xl text-slate-600"></i>
        </button>

        <SedeSelector />

        {/* Left Content (Status de Caja) - Para operadores */}
        {leftContent && (
          <div className="flex-shrink-0">
            {leftContent}
          </div>
        )}
      </div>



      <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
        {/* Profile */}
        <div className="relative">
          <button
            onClick={() => setShowProfile(!showProfile)}
            className="flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2 rounded-xl hover:bg-slate-100 transition"
          >
            <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-sm font-medium">
                {(localStorage.getItem('userName') || 'U')[0].toUpperCase()}
              </span>
            </div>
            <i className="ri-arrow-down-s-line text-slate-600 hidden sm:block"></i>
          </button>

          {showProfile && (
            <>
              {/* Overlay para cerrar al hacer click fuera */}
              <div 
                className="fixed inset-0 z-40"
                onClick={() => setShowProfile(false)}
              />
              <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-slate-200 py-2 z-50">
              <div className="px-4 py-3 border-b border-slate-200">
                <p className="font-medium text-slate-800">
                  {localStorage.getItem('userName') || 'Usuario'}
                </p>
                <p className="text-xs text-slate-500 mt-1">
                  {localStorage.getItem('userRole') || 'OPERADOR'}
                </p>
              </div>
              <div className="border-t border-slate-200 my-2"></div>
              <button
                onClick={onLogout}
                className="w-full px-4 py-2 hover:bg-red-50 transition text-left flex items-center gap-3 whitespace-nowrap"
              >
                <i className="ri-logout-box-line text-red-600"></i>
                <span className="text-sm text-red-600">Cerrar Sesión</span>
              </button>
            </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
